const PopoverContainer = ({
  children,
  className = "dr-w-420",
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      onClick={e => {
        e.stopPropagation();
      }}
      className={`dr-flex dr-flex-col  ${className}`}
    >
      {children}
    </div>
  );
};

export default PopoverContainer;
